import React, { useState, useContext, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Alert } from "react-bootstrap";
import { Calendar, Clock, User, Users, MapPin } from "react-feather";
import Select from "react-select";
import reservasContext from "../../context/reservas/reservasContext";
import authContext from "../../context/authentication/authContex";
import clienteAxios from "../../config/axios";

function ModalNuevaReserva({ show, onHide, cancha, fecha, slot, tipoJuego, onReservaCreada, fechaPresencial = false }) {
  const rContext = useContext(reservasContext);
  //socios se carga una unica vez en reservasContext al iniciar sesion y se refresca por socket.
  const { crearReserva, loading, socios, loadingSocios } = rContext;

  const aContext = useContext(authContext);
  const { usuario, checkIfAdmin, checkIfGestorReservas } = aContext;

  // Estados del formulario
  const [tipoJuegoSeleccionado, setTipoJuegoSeleccionado] = useState(tipoJuego || "SINGLES");
  const [jugadores, setJugadores] = useState([]);
  const [error, setError] = useState(null);
  const [sociosSeleccionados, setSociosSeleccionados] = useState([]);
  const [presencial, setPresencial] = useState(fechaPresencial);

  // Inicializar jugadores según el tipo de juego
  useEffect(() => {
    if (show && tipoJuegoSeleccionado) {
      // SINGLES, SINGLES_45 y SINGLES_PADEL = 2 jugadores, DOBLES/DOBLES_60/DOBLES_PADEL = 4 jugadores
      const cantidadJugadores = (tipoJuegoSeleccionado === "SINGLES" || tipoJuegoSeleccionado === "SINGLES_45" || tipoJuegoSeleccionado === "SINGLES_PADEL") ? 2 : 4;
      const jugadoresIniciales = Array(cantidadJugadores).fill(null).map(() => ({
        nombre: "",
        userNameJ: ""
      }));
      setJugadores(jugadoresIniciales);
      setSociosSeleccionados(Array(cantidadJugadores).fill(null));
    }
  }, [show, tipoJuegoSeleccionado]);

  // Pre-seleccionar al usuario actual como Jugador 1
  useEffect(() => {
    if (show && socios.length > 0 && usuario && jugadores.length > 0) {
      // Buscar el socio que corresponde al usuario actual
      const socioActual = socios.find(socio => socio.userName === usuario.userName);

      if (socioActual && !sociosSeleccionados[0]) {
        // Pre-seleccionar en Jugador 1
        handleSeleccionarSocio(0, socioActual);
      }
    }
  }, [show, socios, usuario, jugadores.length]);

  // Resetear estados al cerrar el modal
  useEffect(() => {
    if (!show) {
      setSociosSeleccionados([]);
      setJugadores([]);
      setError(null);
      setPresencial(false);

      // Limpiar padding-right que Bootstrap Modal agrega al body
      document.body.style.paddingRight = '';
      document.body.style.overflow = '';
    }
  }, [show]);

  // Handler para seleccionar socio en cualquier posición
  const handleSeleccionarSocio = (index, opcionSeleccionada) => {
    const nuevosSociosSeleccionados = [...sociosSeleccionados];
    nuevosSociosSeleccionados[index] = opcionSeleccionada;
    setSociosSeleccionados(nuevosSociosSeleccionados);

    const nuevosJugadores = [...jugadores];
    if (opcionSeleccionada) {
      nuevosJugadores[index] = {
        nombre: opcionSeleccionada.fullName || opcionSeleccionada.userName,
        shortName: opcionSeleccionada.shortName || '',
        userNameJ: opcionSeleccionada.userName,
      };
    } else {
      nuevosJugadores[index] = { nombre: "", shortName: "", userNameJ: "" };
    }
    setJugadores(nuevosJugadores);
  };

  // Obtener opciones disponibles para un selector específico (excluyendo los ya seleccionados en otros)
  const getOpcionesDisponibles = (indexActual) => {
    return socios.filter((socio) => {
      // Verificar si este socio ya está seleccionado en otro índice
      const yaSeleccionado = sociosSeleccionados.some((socioSel, idx) => {
        return idx !== indexActual && socioSel && socioSel.value === socio.value;
      });
      return !yaSeleccionado;
    });
  };

  // Calcular hora de fin y duración según tipo de juego (sistema de slots de 15 minutos)
  const calcularHoraFin = (horaInicio, tipoJuego) => {
    const [horas, minutos] = horaInicio.split(":").map(Number);
    let duracion = 60; // Default: SINGLES = 4 slots (60 min), DOBLES_60 = 4 slots (60 min)
    if (tipoJuego === "SINGLES_45") duracion = 45; // SINGLES_45 = 3 slots (45 min)
    if (tipoJuego === "DOBLES") duracion = 75; // DOBLES tenis = 5 slots (75 min)
    if (tipoJuego === "SINGLES_PADEL" || tipoJuego === "DOBLES_PADEL") duracion = 90; // Pádel = 6 slots (90 min)

    const totalMinutos = horas * 60 + minutos + duracion;
    const nuevasHoras = Math.floor(totalMinutos / 60);
    const nuevosMinutos = totalMinutos % 60;

    return `${String(nuevasHoras).padStart(2, "0")}:${String(nuevosMinutos).padStart(2, "0")}`;
  };

  const getDuracionMinutos = (tipoJuego) => {
    if (tipoJuego === "SINGLES_45") return 45;
    if (tipoJuego === "DOBLES") return 75;
    if (tipoJuego === "SINGLES_PADEL" || tipoJuego === "DOBLES_PADEL") return 90;
    return 60;
  };

  const horaFin = calcularHoraFin(slot.horaInicio, tipoJuegoSeleccionado);
  const duracionMinutos = getDuracionMinutos(tipoJuegoSeleccionado);

  // El tilde "Presencial" siempre se muestra a Admin/Gestor. A los socios se les
  // muestra solo cuando faltan menos de 60 minutos para el comienzo del turno.
  const inicioTurno = new Date(fecha);
  const [horaIni, minIni] = slot.horaInicio.split(":").map(Number);
  inicioTurno.setHours(horaIni, minIni, 0, 0);
  const faltaMenosDe60Min = (inicioTurno.getTime() - Date.now()) < 60 * 60 * 1000;
  const mostrarPresencial = checkIfAdmin() || checkIfGestorReservas() || faltaMenosDe60Min;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      // Validar que todos los jugadores estén seleccionados
      const cantidadEsperada = (tipoJuegoSeleccionado === "SINGLES" || tipoJuegoSeleccionado === "SINGLES_45" || tipoJuegoSeleccionado === "SINGLES_PADEL") ? 2 : 4;
      for (let i = 0; i < cantidadEsperada; i++) {
        if (!jugadores[i] || !jugadores[i].nombre || jugadores[i].nombre.trim() === "") {
          setError(`Debes seleccionar todos los jugadores. Falta el Jugador ${i + 1}`);
          return;
        }
      }

      // Validar que el usuario esté entre los jugadores (solo si no es Admin o Gestor de Reservas)
      const esAdmin = checkIfAdmin();
      const esGestor = checkIfGestorReservas();

      if (!esAdmin && !esGestor) {
        const usuarioEstaEnJugadores = jugadores.some(
          (jugador) => jugador.userNameJ === usuario.userName
        );

        if (!usuarioEstaEnJugadores) {
          setError("Debes incluirte como jugador en la reserva. Solo los administradores y gestores de reservas pueden crear reservas sin participar.");
          return;
        }
      }

      // Todos los jugadores son obligatorios
      const jugadoresFiltrados = jugadores;

      // Validar que ningún jugador tenga reservas que excedan el límite o en el mismo día
      const jugadoresUserNames = jugadores
        .filter(j => j.userNameJ)
        .map(j => j.userNameJ);

      // Formatear fecha en formato YYYY-MM-DD para enviar al backend
      const year = fecha.getFullYear();
      const month = String(fecha.getMonth() + 1).padStart(2, "0");
      const day = String(fecha.getDate()).padStart(2, "0");
      const fechaFormateada = `${year}-${month}-${day}`;

      if (jugadoresUserNames.length > 0) {
        try {
          const token = localStorage.getItem("token");
          const validacionResponse = await clienteAxios.post(
            "/cancha-reservas/validar-jugadores-disponibles",
            {
              jugadoresUserNames,
              fecha: fechaFormateada,
              presencial: presencial,
              tipoJuego: tipoJuegoSeleccionado,
              horaInicio: slot.horaInicio,
              horaFin: horaFin
            },
            { headers: { Authorization: `Bearer ${token}` } }
          );

          const { disponibles, jugadoresOcupados, maxReservasActivas, motivoBloqueo } = validacionResponse.data.data;

          if (!disponibles) {
            if (motivoBloqueo === "SOCIO_BLOQUEADO") {
              const nombres = jugadoresOcupados.map(jo => `${jo.nombre} - ${jo.reserva.motivo}`).join("\n");
              setError(`No se puede crear la reserva. Socio(s) bloqueado(s) para reservar:\n\n${nombres}`);
              return;
            }

            if (motivoBloqueo === "SOCIO_AUTOBLOQUEADO") {
              const motivos = jugadoresOcupados.map(jo => jo.reserva.motivo).join("\n");
              setError(`No se puede crear la reserva.\n\n${motivos}`);
              return;
            }

            const mensajesOcupados = jugadoresOcupados.map(jo => {
              const f = new Date(jo.reserva.fecha);
              const fechaLocal = new Date(f.getUTCFullYear(), f.getUTCMonth(), f.getUTCDate());
              const fechaFormateada = fechaLocal.toLocaleDateString("es-AR");
              return `${jo.nombre} tiene una reserva en ${jo.reserva.cancha} el ${fechaFormateada} de ${jo.reserva.horaInicio} a ${jo.reserva.horaFin}`;
            }).join("\n");

            let mensajeError = "";
            if (motivoBloqueo === "SOLAPAMIENTO_CROSS_DEPORTE") {
              mensajeError = `No se puede crear la reserva porque los siguientes jugadores ya tienen una reserva en otro deporte en el mismo horario:\n\n${mensajesOcupados}`;
            } else if (motivoBloqueo === "MISMO_DIA") {
              mensajeError = `No se puede crear la reserva porque los siguientes jugadores ya tienen una reserva vigente (no finalizada) del mismo deporte en el mismo día:\n\n${mensajesOcupados}`;
            } else if (motivoBloqueo === "LIMITE_GLOBAL") {
              // Si el checkbox Presencial está visible y es LIMITE_GLOBAL, recordar que puede usarlo
              if (mostrarPresencial) {
                mensajeError = `Los siguientes jugadores superan el máximo permitido (${maxReservasActivas}) de reservas vigentes (no finalizadas) del mismo deporte:\n\n${mensajesOcupados}\n\nPuedes marcar "Presencial" para saltear esta validación.`;
              } else {
                mensajeError = `No se puede crear la reserva porque los siguientes jugadores superan el máximo permitido (${maxReservasActivas}) de reservas vigentes (no finalizadas) del mismo deporte:\n\n${mensajesOcupados}`;
              }
            } else {
              mensajeError = `No se puede crear la reserva:\n\n${mensajesOcupados}`;
            }

            setError(mensajeError);
            return;
          }
        } catch (validacionError) {
          console.error("Error al validar jugadores disponibles:", validacionError);
          setError("Error al validar disponibilidad de jugadores");
          return;
        }
      }

      // Preparar datos de la reserva (fechaFormateada ya fue declarada arriba)
      const reservaData = {
        activoID: cancha._id,
        codActivo: cancha.codActivo,
        nameActivo: cancha.name,
        fecha: fechaFormateada,
        horaInicio: slot.horaInicio,
        horaFin: horaFin,
        duracionMinutos: duracionMinutos,
        tipoJuego: tipoJuegoSeleccionado,
        userID: usuario._id,
        userName: usuario.userName,
        userFullName: usuario.fullName,
        userEmail: usuario.email,
        userPhone: usuario.phoneNumber || "",
        jugadores: jugadoresFiltrados,
        requierePago: false,
        presencial: presencial,
      };

      await crearReserva(reservaData);

      // Si llegamos aquí, la reserva se creó exitosamente
      console.log("✅ Reserva creada exitosamente, recargando slots...");
      onReservaCreada();
    } catch (error) {
      console.error("❌ Error al crear reserva:", error);
      setError(error.response?.data?.message || "Error al crear la reserva");
      // Recargar slots incluso si hubo error
      setTimeout(() => {
        onReservaCreada();
      }, 500);
    }
  };

  // Formatear fecha
  const getFechaFormateada = () => {
    const opciones = { weekday: "long", day: "numeric", month: "long", year: "numeric" };
    return fecha.toLocaleDateString("es-AR", opciones);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      style={{ zIndex: 9999 }}
      backdropClassName="modal-backdrop-high-z"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <Calendar size={24} className="me-2" />
          Nueva Reserva
        </Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && (
            <Alert variant="danger" dismissible onClose={() => setError(null)} style={{ whiteSpace: 'pre-line' }}>
              {error}
            </Alert>
          )}

          {/* Checkbox Presencial - Admin/Gestor siempre; socio si falta < 60 min para el turno */}
          {mostrarPresencial && (
            <Alert variant="info" className="mb-3">
              <Form.Check
                type="checkbox"
                id="presencial"
                label="Presencial - Se saltea el límite global de reservas vigentes. El control de una sola reserva por día aplica solo contra otras reservas presenciales."
                checked={presencial}
                onChange={(e) => setPresencial(e.target.checked)}
              />
            </Alert>
          )}

          {/* Información de la reserva */}
          <div className="mb-4 p-3 bg-light rounded">
            <Row>
              <Col md={6}>
                <p className="mb-2">
                  <MapPin size={16} className="me-2" />
                  <strong>Cancha:</strong> {cancha.name}
                </p>
                <p className="mb-2">
                  <Calendar size={16} className="me-2" />
                  <strong>Fecha:</strong> {getFechaFormateada()}
                </p>
              </Col>
              <Col md={6}>
                <p className="mb-2">
                  <Clock size={16} className="me-2" />
                  <strong>Horario:</strong> {slot.horaInicio} - {horaFin}
                </p>
                <p className="mb-2">
                  <User size={16} className="me-2" />
                  <strong>Usuario:</strong> {usuario.userName}
                </p>
              </Col>
            </Row>
          </div>

          {/* Tipo de juego */}
          <Form.Group className="mb-3">
            <Form.Label>
              <strong>Tipo de Juego</strong>
            </Form.Label>
            <div>
              <Form.Check
                inline
                type="radio"
                label="Singles (4 slots - 60 min)"
                name="tipoJuego"
                id="singles"
                value="SINGLES"
                checked={tipoJuegoSeleccionado === "SINGLES"}
                onChange={(e) => setTipoJuegoSeleccionado(e.target.value)}
                disabled
              />
              <Form.Check
                inline
                type="radio"
                label="Singles (3 slots - 45 min)"
                name="tipoJuego"
                id="singles_45"
                value="SINGLES_45"
                checked={tipoJuegoSeleccionado === "SINGLES_45"}
                onChange={(e) => setTipoJuegoSeleccionado(e.target.value)}
                disabled
              />
              <Form.Check
                inline
                type="radio"
                label="Dobles (5 slots - 75 min)"
                name="tipoJuego"
                id="dobles"
                value="DOBLES"
                checked={tipoJuegoSeleccionado === "DOBLES"}
                onChange={(e) => setTipoJuegoSeleccionado(e.target.value)}
                disabled
              />
              <Form.Check
                inline
                type="radio"
                label="Dobles (4 slots - 60 min)"
                name="tipoJuego"
                id="dobles_60"
                value="DOBLES_60"
                checked={tipoJuegoSeleccionado === "DOBLES_60"}
                onChange={(e) => setTipoJuegoSeleccionado(e.target.value)}
                disabled
              />
              <Form.Check
                inline
                type="radio"
                label="Singles Pádel (6 slots - 90 min)"
                name="tipoJuego"
                id="singles_padel"
                value="SINGLES_PADEL"
                checked={tipoJuegoSeleccionado === "SINGLES_PADEL"}
                onChange={(e) => setTipoJuegoSeleccionado(e.target.value)}
                disabled
              />
              <Form.Check
                inline
                type="radio"
                label="Dobles Pádel (6 slots - 90 min)"
                name="tipoJuego"
                id="dobles_padel"
                value="DOBLES_PADEL"
                checked={tipoJuegoSeleccionado === "DOBLES_PADEL"}
                onChange={(e) => setTipoJuegoSeleccionado(e.target.value)}
                disabled
              />
            </div>
            <small className="text-muted">
              El tipo de juego fue seleccionado previamente y no puede modificarse.
            </small>
          </Form.Group>

          <hr />

          {/* Jugadores */}
          <div className="mb-3">
            <div className="mb-3">
              <Form.Label className="mb-0">
                <Users size={18} className="me-2" />
                <strong>Jugadores</strong>
              </Form.Label>
            </div>

            {/* Agrupar jugadores de a 2 por fila */}
            {Array.from({ length: Math.ceil(jugadores.length / 2) }).map((_, rowIndex) => (
              <Row key={rowIndex} className="mb-3">
                {[0, 1].map((colOffset) => {
                  const index = rowIndex * 2 + colOffset;
                  if (index >= jugadores.length) return null;

                  return (
                    <Col md={6} key={index}>
                      <div className="p-3 border rounded h-100">
                        <Form.Group>
                          <Form.Label>
                            <strong className="text-muted">Jugador {index + 1}</strong>
                            <span className="text-danger ms-1">*</span>
                          </Form.Label>
                          <Select
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              control: (base) => ({
                                ...base,
                                borderColor: '#ced4da',
                              }),
                            }}
                            formatOptionLabel={(option) => (
                              <div>
                                <div>{option.fullName || option.userName}</div>
                                {option.userName && option.fullName && (
                                  <div style={{ fontSize: "0.8em", color: "#6c757d" }}>@{option.userName}</div>
                                )}
                              </div>
                            )}
                            placeholder={loadingSocios ? "Cargando socios..." : "Buscar socio..."}
                            options={getOpcionesDisponibles(index)}
                            value={sociosSeleccionados[index]}
                            onChange={(opcion) => handleSeleccionarSocio(index, opcion)}
                            isDisabled={loadingSocios}
                            isClearable
                            isSearchable
                            noOptionsMessage={() => "No hay socios disponibles"}
                          />
                        </Form.Group>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            ))}

            <small className="text-muted">
              {(tipoJuegoSeleccionado === "SINGLES" || tipoJuegoSeleccionado === "SINGLES_45" || tipoJuegoSeleccionado === "SINGLES_PADEL")
                ? "Debes seleccionar los 2 jugadores obligatoriamente."
                : "Debes seleccionar los 4 jugadores obligatoriamente."}
            </small>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={loading}>
            Cancelar
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? "Creando..." : "Confirmar Reserva"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ModalNuevaReserva;
